import { type FC } from "react";
import {
  Chat,
  ControlBar,
  GridLayout,
  ParticipantTile,
  RoomAudioRenderer,
  useTracks,
} from "@livekit/components-react";
import { Track } from "livekit-client";

/** Compat React 19 — tipos do @livekit/components-react ainda retornam ReactNode. */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const GridLayoutView = GridLayout as unknown as FC<any>;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const ParticipantTileView = ParticipantTile as unknown as FC<any>;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const ChatView = Chat as unknown as FC<any>;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const ControlBarView = ControlBar as unknown as FC<any>;

export default function LiveKitVideoPanel() {
  const tracks = useTracks([
    { source: Track.Source.Camera, withPlaceholder: true },
    { source: Track.Source.ScreenShare, withPlaceholder: false },
  ]);

  return (
    <>
      <RoomAudioRenderer />
      <div className="flex h-full flex-col">
        <div className="flex-1 min-h-0 overflow-hidden bg-gray-900">
          <GridLayoutView tracks={tracks} style={{ height: "100%" }}>
            <ParticipantTileView />
          </GridLayoutView>
        </div>
        <div className="h-44 min-h-[9rem] border-t border-gray-700/50 overflow-hidden bg-gray-900/80">
          <ChatView />
        </div>
        <ControlBarView variation="minimal" />
      </div>
    </>
  );
}
